// extracted by mini-css-extract-plugin
module.exports = {"servicesLinkContent":"MoreLink_servicesLinkContent__31o9n","imageContent":"MoreLink_imageContent__2Kd6a","textContent":"MoreLink_textContent__2njj-","name":"MoreLink_name__3-79d"};